module.exports = __webpack_public_path__ + "static/img/8.85e54c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/8.jpg
// module id = 1cKt
// module chunks = 2